import React from 'react';
import { MenuItem, Typography } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

export const MenuGeneratePaymentLink: React.FunctionComponent = function () {
    // Methods to implements
    return (
        <MenuItem
            sx={{ gap: '4px' }}
            onClick={() => {}}
        >
            <FaOptionIcon
                icon={['fasl', 'credit-card']}
                color="text.gris70"
            />
            <Typography sx={{ color: 'text.primary' }}>Générer un lien de paiement</Typography>
        </MenuItem>
    );
};
